import type { AppNavigation } from "./navigation";

export type DetailIdentity = {
  termId: string;
  reviewMode: boolean;
};

export function representsSameDetail(
  current: DetailIdentity | null,
  next: AppNavigation,
): boolean {
  return Boolean(
    next.termId
    && current?.termId === next.termId
    && current.reviewMode === next.reviewMode,
  );
}
